export default "__VITE_ASSET__CG09$K_H__"